module.exports = __webpack_public_path__ + "static/media/pencil.fdd36ec2.svg";